export const SUPPORTED_LANGS = ['en', 'zh-TW', 'zh-CN', 'ja'] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];

export interface DetectInput { cookie: string; acceptLanguage: string }

const COOKIE_NAME = 'sentinel_lang';

function readCookie(cookie: string, name: string): string | null {
  for (const part of cookie.split(';')) {
    const [k, v] = part.trim().split('=');
    if (k === name && v) return decodeURIComponent(v);
  }
  return null;
}

function normalize(tag: string): SupportedLang | null {
  const lower = tag.toLowerCase();
  if (lower === 'en' || lower.startsWith('en-')) return 'en';
  if (lower === 'ja' || lower.startsWith('ja-')) return 'ja';
  if (lower.startsWith('zh-tw') || lower.startsWith('zh-hant')) return 'zh-TW';
  if (lower.startsWith('zh-cn') || lower.startsWith('zh-hans') || lower === 'zh') return 'zh-CN';
  return null;
}

export function detectLanguage({ cookie, acceptLanguage }: DetectInput): SupportedLang {
  const fromCookie = readCookie(cookie, COOKIE_NAME);
  if (fromCookie) {
    const normalized = normalize(fromCookie);
    if (normalized) return normalized;
  }
  for (const tag of acceptLanguage.split(',').map((s) => s.split(';')[0]!.trim())) {
    const normalized = normalize(tag);
    if (normalized) return normalized;
  }
  return 'en';
}
